/* 🤖 this file was generated by svg-to-ts */
export const iconClose: {
    name: 'close';
    data: string;
} = {
    name: 'close',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18"><path fill="#000" fill-rule="evenodd" d="M16.96 1.04a.65.65 0 0 1 .068.84l-.068.08L9.919 9l7.04 7.04a.65.65 0 0 1-.838.988l-.08-.068L9 9.919l-7.04 7.04a.65.65 0 0 1-.988-.838l.068-.08L8.081 9l-7.04-7.04a.65.65 0 0 1 .838-.988l.08.068L9 8.08l7.04-7.04a.65.65 0 0 1 .92 0"/></svg>`
};
